import { CartUpdateEvent } from '@theme/events';

/**
 * Keeps the cart drawer and cart count consistent across the site after a
 * back/forward-cache (bfcache) restore.
 *
 * Problem: add a product on the product page (drawer + count update), then press
 * the browser Back button to a previous page (e.g. a collection). The browser may
 * restore that page from bfcache — a frozen snapshot captured BEFORE the add — so
 * its cart drawer shows empty and the count is stale.
 *
 * Fix: when a page is restored from bfcache, fetch the real cart and dispatch the
 * theme's CartUpdateEvent. The existing consumers then re-sync themselves:
 *  - cart-items-component re-renders the drawer section from the server, and
 *  - cart-icon updates the bubble count to the authoritative item_count.
 * (cart-drawer-component is told not to auto-open for this source — see cart-drawer.js.)
 */
window.addEventListener('pageshow', (event) => {
  // Only act on bfcache restores. A normal load already renders the correct cart.
  if (!event.persisted) return;

  const cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';

  fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } })
    .then((response) => (response.ok ? response.json() : null))
    .then((cart) => {
      if (!cart) return;
      document.dispatchEvent(
        new CartUpdateEvent(cart, 'bfcache-restore', {
          itemCount: cart.item_count,
          source: 'bfcache-restore',
        })
      );
    })
    .catch(() => {
      /* network hiccup — leave the page as-is */
    });
});
